<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">录入交割信息</h3>
    </Modal>
  </div>


</template>
<script>
  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },

    },
    watch:{
      n(){
        this.isShow=true
      }
    },
    data(){
      return {
        loading: true,
        isShow:false,
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){

      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
